package csaware.utilities

import csaware.messages.CsawareMessagesObject.csawareMessageStrategy
import kafffe.bootstrap.BasicColor
import kafffe.bootstrap.ModalSize
import kafffe.bootstrap.form.FormDialog
import kafffe.bootstrap.form.TextArea
import kafffe.bootstrap.form.textArea
import kafffe.core.KafffeComponent
import kafffe.core.Model
import kafffe.core.modifiers.CssClassModifier
import kafffe.core.modifiers.CssClassModifier.Companion.cssClassModifier
import kafffe.core.modifiers.StyleModifier
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event
import org.w3c.files.FileList
import org.w3c.files.FileReader
import org.w3c.files.get

class FileImportDlg(titleModel: Model<String>, messagePrefix: String) :
        FormDialog<String>(titleModel, Model.of("")) {

    val fileData: Model<String> = Model.of("")
    var textField: TextArea? = null

    inner class FileInput : KafffeComponent() {
        val input = htmlStart.input {
            addClass("form-control-file")
            withElement {
                type = "file"
                onchange = { changeEvent: Event ->
                    val files: FileList = changeEvent.target.asDynamic().files.unsafeCast<FileList>() // FileList object
                    if (files.length == 1) {
                        val reader = FileReader()
                        reader.onload = {
                            fileData.data = reader.result as String
                            textField?.rerender()
                        }

                        // Read in the image file as a data URL.
                        reader.readAsText(files[0]!!)
                        changeEvent.preventDefault()
                    }
                }
            }
        }.element

        override fun createHtml(): HTMLElement {
            return input
        }
    }

    private val fileInput = FileInput()

    init {
        labelStrategy = csawareMessageStrategy(messagePrefix)
        size = ModalSize.large
        modal.modifiersBody.add(StyleModifier {
            overflowY = "auto"
            maxHeight = "75vh"
        })
        modal.modifiersModal.add(StyleModifier {
            maxWidth = "90vw"
            width = "1400px"
        })
        modal.modifiersContent.add(CssClassModifier("bg-light"))
        cssClassModifier("vgap-3 hgap-3")
        addChild(fileInput)

        textField = textArea("data", Model.of("JSON"), fileData).apply {
            lines = 24
            modifiers.add(StyleModifier { maxHeight = "55vh"} )
        }
        submit().apply {
            color = BasicColor.primary
            cssClassModifier("me-2") // add space to the right after submit
        }
        cancel().color = BasicColor.secondary
    }

}

